<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, defineProps, } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import InfoBoxBottom from '@/components/cloudCounter/InfoBoxBottom.vue';

const goNextPage = () => {
    console.log('Go! Go! Go!');
}

// 選擇資格證明彈窗
const eligibleInfoBoxVisible = ref(false);

// 上傳相關證明文件彈窗
const fileInfoBoxVisible = ref(false);


const fileInput = ref(null);

const fileList = ref([]);
const addFile = (e) => {
    console.log(fileInput.value);

    if (e.target.files[0].size > 5242880) {
        console.log('Too big!');
        return;
    }

    if (e.target.files[0]) {
        fileList.value.push({
            id: (new Date()).getTime(),
            name: e.target.files[0].name,
            src: URL.createObjectURL(e.target.files[0]),
            type: e.target.files[0].type,
        });
    }

    fileInput.value.value = null;

}

const removeFile = (id) => {
    const _index = fileList.value.findIndex(x => x.id == id);
    fileList.value.splice(_index, 1);
}



</script>

<template>
    <Layout :header="{ text: '保單借款', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">
        <InfoBoxBottom boxTitle="選擇資格證明" :closeHandle="() => { eligibleInfoBoxVisible = false }"
            v-show="eligibleInfoBoxVisible">

            <ul>
                <li class="py-4 border-b">
                    <label class="flex w-full">
                        <div class="pt-0.5 pr-2">
                            <input type="radio" name="prove" value="">
                        </div>
                        <div>經濟弱勢保戶線上保單借款證明文件申請<br>(身心障礙資格)</div>
                    </label>
                </li>
                <li class="py-4 border-b">
                    <label class="flex w-full">
                        <div class="pt-0.5 pr-2">
                            <input type="radio" name="prove" value="">
                        </div>
                        <div>經濟弱勢保戶線上保單借款證明文件申請<br>(低收入戶或中低收入戶證明)</div>
                    </label>
                </li>
            </ul>


            <template #fixedBotton>
                <div class="footer-shadow">
                    <div class="flex w-full px-2 py-3 max-w-[768px] mx-auto">
                        <div class="flex-1 px-2">
                            <RouterLink class="block py-3 text-center rounded bg-[#CCF3FF] text-[#0093C1]"
                                :to="{ name: '' }">
                                不申請
                            </RouterLink>
                        </div>
                        <div class="flex-1 px-2">
                            <RouterLink class="block py-3 text-center rounded bg-[#0093C1] text-white"
                                :to="{ name: '' }">
                                符合資格並申請
                            </RouterLink>
                        </div>
                    </div>
                </div>
            </template>
        </InfoBoxBottom>

        <InfoBoxBottom boxTitle="上傳相關證明文件" :closeHandle="() => { fileInfoBoxVisible = false }"
            v-show="fileInfoBoxVisible">
            <div class="pb-4" v-for="fileItem in fileList">
                <div class="w-full bg-[#DFE4E5] rounded-md p-4">
                    <div class="w-full flex justify-between items-center pb-4">
                        <div class="font-bold">{{ fileItem.name }}</div>
                        <div>
                            <!-- 刪除按鈕 -->
                            <button @click="(e) => { removeFile(fileItem.id); }">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 5L22 5" stroke="#0093C1" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M4 6L5.93247 19.5273C6.13516 20.9461 7.35029 22 8.78352 22H15.2165C16.6497 22 17.8648 20.9461 18.0675 19.5273L20 6"
                                        stroke="#0093C1" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M9.46387 8.26855V17.4881" stroke="#0093C1" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M14.293 8.48828V17.7078" stroke="#0093C1" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M7.70752 4.63415C7.94699 3.7561 9.09643 2 11.7785 2C14.4605 2 15.4503 3.7561 15.61 4.63415"
                                        stroke="#0093C1" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div class="text-center">
                        <img v-if="fileItem.type.includes('image')" class="inline-block max-w-[220px]"
                            :src="fileItem.src" />
                    </div>
                </div>
            </div>

            <div class="pb-7">
                <div class="w-full bg-[#DFE4E5] rounded-md">

                    <label class="block w-full h-[144px] relative">
                        <input class="w-full h-full opacity-0 relative z-20" type="file"
                            accept=".doc,.docx,.pdf,.jpg,.jpeg,.tif,.tiff,.gif" ref="fileInput" @change="addFile" />
                        <div
                            class="absolute top-0 left-0 right-0 bottom-0 z-10 flex items-center justify-center text-center">
                            <div>
                                <div class="inline-block pb-2">
                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12.5" cy="12" r="10" fill="#0093C1" />
                                        <path d="M12.5 7.5V16.4999" stroke="white" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M17 12H8.00009" stroke="white" stroke-width="1.95"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="font-bold">
                                    <template v-if="fileList.length === 0">上傳文件</template>
                                    <template v-else>繼續上傳其他文件</template>
                                </div>
                                <div class="text-sm">
                                    限 jpg、jpeg、pdf、word檔（.doc、.docx）tif、tiff、gif，不超過 5 MB
                                </div>
                            </div>
                        </div>
                    </label>
                </div>
            </div>

            <ul class="list-disc pb-7 pl-4 text-sm">
                <li>請提供完整頁面，避免裁切、折角、反光與陰影</li>
            </ul>

            <button
                class="w-full py-3 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F] rounded-md"
                :disabled="fileList.length === 0" @click="(e) => { goNextPage() }"> 下一步
            </button>

        </InfoBoxBottom>

        <div class="pt-2 pb-6">
            <Process :steps="['同意條款', '選擇保單', '確認資料', '手機驗證',]" :index="1"></Process>
        </div>

        <div class="pb-4 flex justify-between items-center">
            <h2 class="font-bold text-2xl">提供相關身份證明文件</h2>
        </div>

        <div class="pb-4">
            <div class="flex justify-between items-center  p-4 rounded-md bg-white">
                <div class="pr-4">
                    <div class="font-bold">自行上傳相關證明文件</div>
                    <div class="text-sm">所有資格的申請者皆可使用</div>
                </div>
                <div>
                    <button class=" p-1.5 min-w-[72px] text-white text-sm text-center bg-[#0093C1]  rounded-md"
                        @click="(e) => { fileInfoBoxVisible = true; }">上傳</button>
                </div>
            </div>
        </div>
        <div class="pb-4">
            <div class="flex justify-between items-center  p-4 rounded-md bg-white">
                <div class="pr-4">
                    <div class="font-bold">數發部 My data 平台授權提供</div>
                    <div class="text-sm">身心障礙資格、低/中低收入戶證明，可透過數發部「個人資料自主運用平臺（My data）」提供</div>
                </div>
                <div>
                    <button class=" p-1.5 min-w-[72px] text-white text-sm text-center bg-[#0093C1]  rounded-md"
                        @click="(e) => { eligibleInfoBoxVisible = true; }">授權</button>
                </div>
            </div>
        </div>

    </Layout>

</template>

<style scoped></style>